<template>
  <div>
    <phone-numbers ref="phoneNumbers" v-model="model.phoneNumbers"/>
    <emails ref="emails" v-model="model.emails"/>
    <websites ref="websites" v-model="model.websites"/>
    <addresses ref="addresses" v-model="model.addresses"/>
  </div>
</template>

<script>
import Addresses from './Addresses/index'
import Emails from './Emails/index'
import PhoneNumbers from './PhoneNumbers/index'
import Websites from './Websites/index'

export default {
  name: 'Fields',
  components: {
    Addresses,
    Emails,
    PhoneNumbers,
    Websites
  },
  props: {
    value: Object
  },
  computed: {
    model:{
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    validateAll () {
      const validates = []
      validates.push(this.$refs.phoneNumbers.validateAll())
      validates.push(this.$refs.emails.validateAll())
      validates.push(this.$refs.websites.validateAll())
      validates.push(this.$refs.addresses.validateAll())
      return Promise.all(validates).then(all => {
        return all.every(v => v)
      })
    }
  }
}
</script>
